var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    [
      _c(
        "md-card-header",
        { staticClass: "md-card-header-icon md-card-header-green" },
        [
          _c(
            "div",
            { staticClass: "card-icon" },
            [_c("md-icon", [_vm._v("inventory")])],
            1
          ),
        ]
      ),
      _c("md-card-content", [
        !_vm.items || _vm.items.length === 0
          ? _c("p", { staticClass: "grayedout-text text-center" }, [
              _vm._v("\n            No items found\n        "),
            ])
          : _c("div", [
              _c(
                "div",
                {
                  staticClass: "item-table-container",
                  class: { "with-scroll": _vm.enableScroll },
                },
                [
                  _c(
                    "md-table",
                    {
                      staticClass:
                        "context-menu-support custom-paginated-table",
                    },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c("md-table-head", [_vm._v("Reference")]),
                          _c("md-table-head", [_vm._v("Status")]),
                          _c("md-table-head", [_vm._v("Barcode")]),
                          _c("md-table-head", [_vm._v("Description")]),
                          _vm.$_isLoadCapacityTypeEnabled(
                            _vm.loadCapacityList,
                            "Volume"
                          )
                            ? _c(
                                "md-table-head",
                                { staticClass: "volume-column" },
                                [
                                  _vm._v(
                                    "\n                            V\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.$_isLoadCapacityTypeEnabled(
                            _vm.loadCapacityList,
                            "Weight"
                          )
                            ? _c(
                                "md-table-head",
                                { staticClass: "width-column" },
                                [
                                  _vm._v(
                                    "\n                            Wt\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.$root.isDesktop && !_vm.isReadOnlyUser
                            ? _c(
                                "md-table-head",
                                { staticClass: "actions-column" },
                                [
                                  _vm._v(
                                    "\n                            Actions\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._l(_vm.items, function (item) {
                        return _c(
                          "md-table-row",
                          { key: item.itemId },
                          [
                            _c(
                              "md-table-cell",
                              [
                                !item.shipmentDetails.shipmentId
                                  ? _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "Stop Details",
                                            params: { stopId: item.stopId },
                                          },
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        item.stopDetails.sourceReference
                                          ? [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.stopDetails
                                                      .sourceReference
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.stopDetails.stopRef
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ],
                                      ],
                                      2
                                    )
                                  : _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "Shipment Details",
                                            params: {
                                              shipmentId:
                                                item.shipmentDetails.shipmentId,
                                            },
                                          },
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        item.shipmentDetails.sourceReference
                                          ? [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.shipmentDetails
                                                      .sourceReference
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    item.shipmentDetails
                                                      .shipmentRef
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                              ],
                              1
                            ),
                            _c("md-table-cell", [
                              _c(
                                "div",
                                {
                                  class:
                                    "custom-badge inventory-status inventory-status-" +
                                    item.status
                                      .toLowerCase()
                                      .replace(/\s+/g, ""),
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "inputs.itemStatuses." + item.status
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                            _c("md-table-cell", [_vm._v(_vm._s(item.barcode))]),
                            _c("md-table-cell", [
                              _vm._v(_vm._s(item.description)),
                            ]),
                            _vm.$_isLoadCapacityTypeEnabled(
                              _vm.loadCapacityList,
                              "Volume"
                            )
                              ? _c(
                                  "md-table-cell",
                                  { staticClass: "volume-column" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$_displayLoadValue(
                                            _vm.loadCapacityList,
                                            item.load,
                                            "Volume"
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.$_isLoadCapacityTypeEnabled(
                              _vm.loadCapacityList,
                              "Weight"
                            )
                              ? _c(
                                  "md-table-cell",
                                  { staticClass: "width-column" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$_displayLoadValue(
                                            _vm.loadCapacityList,
                                            item.load,
                                            "Weight"
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.$root.isDesktop && !_vm.isReadOnlyUser
                              ? _c(
                                  "md-table-cell",
                                  { staticClass: "actions-column" },
                                  [
                                    !_vm.isReadOnlyUser
                                      ? _c("update-item-button", {
                                          attrs: {
                                            item: item,
                                            "is-delivered":
                                              item.status === "Delivered",
                                            "stop-status": item.stopStatus,
                                            "is-invoiced":
                                              item.stopDetails.isInvoiced,
                                          },
                                          on: {
                                            itemUpdated: _vm.handleUpdateItem,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "item-totals-container",
                  class: { "with-scroll": _vm.enableScroll },
                },
                [
                  _c(
                    "md-table",
                    {
                      staticClass:
                        "context-menu-support custom-paginated-table",
                    },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c("md-table-cell", [
                            _c("strong", [_vm._v("Total")]),
                          ]),
                          _c("md-table-cell"),
                          _c("md-table-cell"),
                          _c(
                            "md-table-cell",
                            { staticClass: "item-count-column" },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.items.length) + " items"),
                              ]),
                            ]
                          ),
                          _vm.$_isLoadCapacityTypeEnabled(
                            _vm.loadCapacityList,
                            "Volume"
                          )
                            ? _c(
                                "md-table-cell",
                                { staticClass: "volume-column" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.loadTotals.volume) +
                                        "\n                                " +
                                        _vm._s(
                                          _vm.loadCapacityList.find(function (
                                            l
                                          ) {
                                            return l.label === "Volume"
                                          }).symbol
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.$_isLoadCapacityTypeEnabled(
                            _vm.loadCapacityList,
                            "Weight"
                          )
                            ? _c(
                                "md-table-cell",
                                { staticClass: "width-column" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.loadTotals.weight) +
                                        "\n                                " +
                                        _vm._s(
                                          _vm.loadCapacityList.find(function (
                                            l
                                          ) {
                                            return l.label === "Weight"
                                          }).symbol
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c("md-table-cell", {
                            staticClass: "actions-column",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }